import React from 'react';
import { DateTime } from 'luxon';
const getWeekDescription = () => {
  const today = DateTime.local();
  const end_date = today.toFormat('MM/dd');
  const start_date = today.minus({
    days: 6
  }).toFormat('MM/dd');
  const start_date_last_week = today.minus({
    days: 13
  }).toFormat('MM/dd');
  const end_date_last_week = today.minus({
    days: 7
  }).toFormat('MM/dd');
  return {
    this_week: `${start_date} - ${end_date}`,
    last_week: `${start_date_last_week} - ${end_date_last_week}`
  };
};
export const BarChartComponent = ({
  thisWeek,
  lastWeek
}) => {
  const barHeight = () => {
    if (!thisWeek && !lastWeek) return '0px';
    if (lastWeek <= thisWeek) return `${lastWeek * 280 / thisWeek}px`;
    if (thisWeek <= lastWeek) return `${thisWeek * 280 / lastWeek}px`;
  };
  const lastWeekRender = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: `last-week ${lastWeek >= thisWeek ? 'green' : 'red'}`,
      style: {
        height: `${lastWeek > thisWeek ? '280px' : barHeight()}`
      }
    }, lastWeek ? `${Math.round(lastWeek)}%` : '-');
  };
  const {
    this_week,
    last_week
  } = getWeekDescription();
  return /*#__PURE__*/React.createElement("div", {
    className: "weekly-comparison"
  }, /*#__PURE__*/React.createElement("p", {
    className: "title"
  }, "Weekly Comparison"), /*#__PURE__*/React.createElement("div", {
    className: "bar-chart"
  }, lastWeekRender(), /*#__PURE__*/React.createElement("div", {
    className: `this-week ${thisWeek >= lastWeek ? 'green' : 'red'}`,
    style: {
      height: `${thisWeek > lastWeek ? '280px' : barHeight()}`
    }
  }, thisWeek ? `${Math.round(thisWeek)}%` : '-')), /*#__PURE__*/React.createElement("div", {
    className: "chart-legend"
  }, /*#__PURE__*/React.createElement("p", {
    className: "last-week-legend"
  }, last_week), /*#__PURE__*/React.createElement("p", {
    className: "this-week-legend"
  }, this_week)));
};